"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterOptionsFromJSON = FilterOptionsFromJSON;
exports.FilterOptionsFromJSONTyped = FilterOptionsFromJSONTyped;
exports.FilterOptionsToJSON = FilterOptionsToJSON;
exports.FilterOptionsToJSONTyped = FilterOptionsToJSONTyped;
const runtime_1 = require("../runtime");
function FilterOptionsFromJSON(json) {
    return FilterOptionsFromJSONTyped(json, false);
}
function FilterOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': !(0, runtime_1.exists)(json, 'label') ? undefined : json['label'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'value': !(0, runtime_1.exists)(json, 'value') ? undefined : json['value'],
    };
}
function FilterOptionsToJSON(value) {
    return FilterOptionsToJSONTyped(value, false);
}
function FilterOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'label': value.label,
        'name': value.name,
        'value': value.value,
    };
}
